import axios from 'axios'
import store from '@/store'

export default {
  getAllPermission () {
    return new Promise((resolve, reject) => {
      axios.get('/api/permissions').then(({ data }) => {
        store.dispatch('setAllPermission', data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  }
}
